import React from 'react';
import { Typography } from '@mui/material';

const Roles: React.FC = () => {
  return (
    <Typography variant="body1">Roles management coming soon...</Typography>
  );
};

export default Roles;
